/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BaseHit Api
 * An API for accessing data for BaseHit.com
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorResult,
  GetPlayerIdGameLogParams,
  GetPlayerIdStatsParams,
  PlayerAchievementsAwardsResponse,
  PlayerAdvancedDefenseResponse,
  PlayerGameLogResponse,
  PlayerHistoryResponse,
  PlayerPositionRatingsResponse,
  PlayerReassignRequest,
  PlayerRenameRequest,
  PlayerSplitStatsResponse,
  PlayerStatsResponse,
  PlayerViewResponse,
  ProblemDetails
} from '../models';

import { fetcher } from '../../fetcher';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Player achievements + awards. Requires auth. 404 when player or league missing.
 */
export const getPlayerIdAchievementsAwards = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<PlayerAchievementsAwardsResponse>(
      {url: `/Player/${id}/AchievementsAwards`, method: 'GET', signal
    },
      );
    }




export const getGetPlayerIdAchievementsAwardsQueryKey = (id: number,) => {
    return [
    `/Player/${id}/AchievementsAwards`
    ] as const;
    }


export const getGetPlayerIdAchievementsAwardsQueryOptions = <TData = Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlayerIdAchievementsAwardsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>> = ({ signal }) => getPlayerIdAchievementsAwards(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlayerIdAchievementsAwardsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>>
export type GetPlayerIdAchievementsAwardsQueryError = ProblemDetails


export function useGetPlayerIdAchievementsAwards<TData = Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdAchievementsAwards<TData = Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdAchievementsAwards<TData = Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Player achievements + awards. Requires auth. 404 when player or league missing.
 */

export function useGetPlayerIdAchievementsAwards<TData = Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAchievementsAwards>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlayerIdAchievementsAwardsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Rename a player (commissioner/admin). 400 on validation/rule failure.
 */
export const putPlayerIdName = (
    id: number,
    playerRenameRequest?: PlayerRenameRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Player/${id}/Name`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: playerRenameRequest, signal
    },
      );
    }




export const getPutPlayerIdNameMutationKey = () => ['putPlayerIdName'] as const;

export const getPutPlayerIdNameMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPlayerIdName>>, TError,PutPlayerIdNameMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putPlayerIdName>>, TError,PutPlayerIdNameMutationVariables, TContext> => {

const mutationKey = getPutPlayerIdNameMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPlayerIdName>>, PutPlayerIdNameMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putPlayerIdName(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPlayerIdNameMutationResult = NonNullable<Awaited<ReturnType<typeof putPlayerIdName>>>
    export type PutPlayerIdNameMutationBody = PlayerRenameRequest | undefined
    export type PutPlayerIdNameMutationError = ErrorResult | ProblemDetails
    export type PutPlayerIdNameMutationVariables = {id: number;data?: PlayerRenameRequest}

    /**
 * @summary Rename a player (commissioner/admin). 400 on validation/rule failure.
 */
export const usePutPlayerIdName = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPlayerIdName>>, TError,PutPlayerIdNameMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPlayerIdName>>,
        TError,
        PutPlayerIdNameMutationVariables,
        TContext
      > => {
      return useMutation(getPutPlayerIdNameMutationOptions(options), queryClient);
    }
    /**
 * @summary Reassign a player to a team (teamId 0 = free agency). Commissioner/admin.
 */
export const putPlayerIdReassign = (
    id: number,
    playerReassignRequest?: PlayerReassignRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Player/${id}/Reassign`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: playerReassignRequest, signal
    },
      );
    }




export const getPutPlayerIdReassignMutationKey = () => ['putPlayerIdReassign'] as const;

export const getPutPlayerIdReassignMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPlayerIdReassign>>, TError,PutPlayerIdReassignMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putPlayerIdReassign>>, TError,PutPlayerIdReassignMutationVariables, TContext> => {

const mutationKey = getPutPlayerIdReassignMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPlayerIdReassign>>, PutPlayerIdReassignMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putPlayerIdReassign(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPlayerIdReassignMutationResult = NonNullable<Awaited<ReturnType<typeof putPlayerIdReassign>>>
    export type PutPlayerIdReassignMutationBody = PlayerReassignRequest | undefined
    export type PutPlayerIdReassignMutationError = ErrorResult | ProblemDetails
    export type PutPlayerIdReassignMutationVariables = {id: number;data?: PlayerReassignRequest}

    /**
 * @summary Reassign a player to a team (teamId 0 = free agency). Commissioner/admin.
 */
export const usePutPlayerIdReassign = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPlayerIdReassign>>, TError,PutPlayerIdReassignMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPlayerIdReassign>>,
        TError,
        PutPlayerIdReassignMutationVariables,
        TContext
      > => {
      return useMutation(getPutPlayerIdReassignMutationOptions(options), queryClient);
    }
    /**
 * @summary Defensive RAA by area per regular season, with per-(team, position) detail and a
            career row. Requires auth. 404 when the player or league is missing or the league does not
            have the advanced-defense-stats flag.
 */
export const getPlayerIdAdvancedDefense = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<PlayerAdvancedDefenseResponse>(
      {url: `/Player/${id}/AdvancedDefense`, method: 'GET', signal
    },
      );
    }




export const getGetPlayerIdAdvancedDefenseQueryKey = (id: number,) => {
    return [
    `/Player/${id}/AdvancedDefense`
    ] as const;
    }


export const getGetPlayerIdAdvancedDefenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlayerIdAdvancedDefenseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>> = ({ signal }) => getPlayerIdAdvancedDefense(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlayerIdAdvancedDefenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>>
export type GetPlayerIdAdvancedDefenseQueryError = ProblemDetails


export function useGetPlayerIdAdvancedDefense<TData = Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdAdvancedDefense<TData = Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdAdvancedDefense<TData = Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Defensive RAA by area per regular season, with per-(team, position) detail and a
            career row. Requires auth. 404 when the player or league is missing or the league does not
            have the advanced-defense-stats flag.
 */

export function useGetPlayerIdAdvancedDefense<TData = Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdAdvancedDefense>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlayerIdAdvancedDefenseQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Player game log for a season (omitted ⇒ last-played season). Requires auth.
            404 when player/league missing or the requested season is out of the player's range.
 */
export const getPlayerIdGameLog = (
    id: number,
    params?: GetPlayerIdGameLogParams,
 signal?: AbortSignal
) => {


      return fetcher<PlayerGameLogResponse>(
      {url: `/Player/${id}/GameLog`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetPlayerIdGameLogQueryKey = (id: number,
    params?: GetPlayerIdGameLogParams,) => {
    return [
    `/Player/${id}/GameLog`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlayerIdGameLogQueryOptions = <TData = Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError = ProblemDetails>(id: number,
    params?: GetPlayerIdGameLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlayerIdGameLogQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayerIdGameLog>>> = ({ signal }) => getPlayerIdGameLog(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlayerIdGameLogQueryResult = NonNullable<Awaited<ReturnType<typeof getPlayerIdGameLog>>>
export type GetPlayerIdGameLogQueryError = ProblemDetails


export function useGetPlayerIdGameLog<TData = Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetPlayerIdGameLogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdGameLog>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdGameLog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdGameLog<TData = Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError = ProblemDetails>(
 id: number,
    params?: GetPlayerIdGameLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdGameLog>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdGameLog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdGameLog<TData = Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError = ProblemDetails>(
 id: number,
    params?: GetPlayerIdGameLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Player game log for a season (omitted ⇒ last-played season). Requires auth.
            404 when player/league missing or the requested season is out of the player's range.
 */

export function useGetPlayerIdGameLog<TData = Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError = ProblemDetails>(
 id: number,
    params?: GetPlayerIdGameLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdGameLog>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlayerIdGameLogQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Player ratings/salary history + transaction log. Requires auth.
            404 when player/league missing or the league has no regular season.
 */
export const getPlayerIdHistory = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<PlayerHistoryResponse>(
      {url: `/Player/${id}/History`, method: 'GET', signal
    },
      );
    }




export const getGetPlayerIdHistoryQueryKey = (id: number,) => {
    return [
    `/Player/${id}/History`
    ] as const;
    }


export const getGetPlayerIdHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getPlayerIdHistory>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlayerIdHistoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayerIdHistory>>> = ({ signal }) => getPlayerIdHistory(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlayerIdHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getPlayerIdHistory>>>
export type GetPlayerIdHistoryQueryError = ProblemDetails


export function useGetPlayerIdHistory<TData = Awaited<ReturnType<typeof getPlayerIdHistory>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdHistory>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdHistory<TData = Awaited<ReturnType<typeof getPlayerIdHistory>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdHistory>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdHistory<TData = Awaited<ReturnType<typeof getPlayerIdHistory>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Player ratings/salary history + transaction log. Requires auth.
            404 when player/league missing or the league has no regular season.
 */

export function useGetPlayerIdHistory<TData = Awaited<ReturnType<typeof getPlayerIdHistory>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlayerIdHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The slim alternative to `GET /Player/{id}/View` for callers that only want these
 * numbers -- roughly three database reads instead of seven, and the popover opens once per
 * pill click on pages that render dozens of pills. Not user-aware: every value here is a
 * property of the player and his league's display rules, so there is nothing to vary by
 * viewer.
 * @summary Per-position ratings for the Multi-Position position popover: Range, Glove, Arm
            and both overalls at each position the player is carded at, primary first. Requires auth.
            Returns an EMPTY list (200, not 404) when the player's league's current season is not
            running Multi-Position or he has no card; 404 means the player does not exist.
 */
export const getPlayerIdPositionRatings = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<PlayerPositionRatingsResponse>(
      {url: `/Player/${id}/PositionRatings`, method: 'GET', signal
    },
      );
    }




export const getGetPlayerIdPositionRatingsQueryKey = (id: number,) => {
    return [
    `/Player/${id}/PositionRatings`
    ] as const;
    }


export const getGetPlayerIdPositionRatingsQueryOptions = <TData = Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlayerIdPositionRatingsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayerIdPositionRatings>>> = ({ signal }) => getPlayerIdPositionRatings(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlayerIdPositionRatingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlayerIdPositionRatings>>>
export type GetPlayerIdPositionRatingsQueryError = ProblemDetails


export function useGetPlayerIdPositionRatings<TData = Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdPositionRatings>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdPositionRatings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdPositionRatings<TData = Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdPositionRatings>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdPositionRatings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdPositionRatings<TData = Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Per-position ratings for the Multi-Position position popover: Range, Glove, Arm
            and both overalls at each position the player is carded at, primary first. Requires auth.
            Returns an EMPTY list (200, not 404) when the player's league's current season is not
            running Multi-Position or he has no card; 404 means the player does not exist.
 */

export function useGetPlayerIdPositionRatings<TData = Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdPositionRatings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlayerIdPositionRatingsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Combined player Home/Away split stats + situational stats for the
            split-stats page (#558). Splits are one batting OR pitching table by position;
            situational is always batting-shaped (pitchers show opponent-against events).
            Requires auth. 404 when player/league missing or the league has no regular season.
 */
export const getPlayerIdSplitStats = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<PlayerSplitStatsResponse>(
      {url: `/Player/${id}/SplitStats`, method: 'GET', signal
    },
      );
    }




export const getGetPlayerIdSplitStatsQueryKey = (id: number,) => {
    return [
    `/Player/${id}/SplitStats`
    ] as const;
    }


export const getGetPlayerIdSplitStatsQueryOptions = <TData = Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlayerIdSplitStatsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayerIdSplitStats>>> = ({ signal }) => getPlayerIdSplitStats(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlayerIdSplitStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlayerIdSplitStats>>>
export type GetPlayerIdSplitStatsQueryError = ProblemDetails


export function useGetPlayerIdSplitStats<TData = Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdSplitStats>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdSplitStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdSplitStats<TData = Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdSplitStats>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdSplitStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdSplitStats<TData = Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Combined player Home/Away split stats + situational stats for the
            split-stats page (#558). Splits are one batting OR pitching table by position;
            situational is always batting-shaped (pitchers show opponent-against events).
            Requires auth. 404 when player/league missing or the league has no regular season.
 */

export function useGetPlayerIdSplitStats<TData = Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdSplitStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlayerIdSplitStatsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Player season/playoff stats (standard + extended + fielding). Requires auth.
            part = regular|playoffs. 404 when player/league missing, or part=regular when the league
            has no regular season; invalid part value ⇒ 404.
 */
export const getPlayerIdStats = (
    id: number,
    params?: GetPlayerIdStatsParams,
 signal?: AbortSignal
) => {


      return fetcher<PlayerStatsResponse>(
      {url: `/Player/${id}/Stats`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetPlayerIdStatsQueryKey = (id: number,
    params?: GetPlayerIdStatsParams,) => {
    return [
    `/Player/${id}/Stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPlayerIdStatsQueryOptions = <TData = Awaited<ReturnType<typeof getPlayerIdStats>>, TError = ProblemDetails>(id: number,
    params?: GetPlayerIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlayerIdStatsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayerIdStats>>> = ({ signal }) => getPlayerIdStats(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlayerIdStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlayerIdStats>>>
export type GetPlayerIdStatsQueryError = ProblemDetails


export function useGetPlayerIdStats<TData = Awaited<ReturnType<typeof getPlayerIdStats>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetPlayerIdStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdStats>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdStats<TData = Awaited<ReturnType<typeof getPlayerIdStats>>, TError = ProblemDetails>(
 id: number,
    params?: GetPlayerIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdStats>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdStats<TData = Awaited<ReturnType<typeof getPlayerIdStats>>, TError = ProblemDetails>(
 id: number,
    params?: GetPlayerIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Player season/playoff stats (standard + extended + fielding). Requires auth.
            part = regular|playoffs. 404 when player/league missing, or part=regular when the league
            has no regular season; invalid part value ⇒ 404.
 */

export function useGetPlayerIdStats<TData = Awaited<ReturnType<typeof getPlayerIdStats>>, TError = ProblemDetails>(
 id: number,
    params?: GetPlayerIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlayerIdStatsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Player Summary page payload (bio, ratings, career stats, franchise
            highlights, admin flags). Requires auth; user-aware. 404 when the player is missing.
 */
export const getPlayerIdView = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<PlayerViewResponse>(
      {url: `/Player/${id}/View`, method: 'GET', signal
    },
      );
    }




export const getGetPlayerIdViewQueryKey = (id: number,) => {
    return [
    `/Player/${id}/View`
    ] as const;
    }


export const getGetPlayerIdViewQueryOptions = <TData = Awaited<ReturnType<typeof getPlayerIdView>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdView>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlayerIdViewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayerIdView>>> = ({ signal }) => getPlayerIdView(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdView>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlayerIdViewQueryResult = NonNullable<Awaited<ReturnType<typeof getPlayerIdView>>>
export type GetPlayerIdViewQueryError = ProblemDetails


export function useGetPlayerIdView<TData = Awaited<ReturnType<typeof getPlayerIdView>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdView>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdView>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdView<TData = Awaited<ReturnType<typeof getPlayerIdView>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdView>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlayerIdView>>,
          TError,
          Awaited<ReturnType<typeof getPlayerIdView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlayerIdView<TData = Awaited<ReturnType<typeof getPlayerIdView>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdView>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Player Summary page payload (bio, ratings, career stats, franchise
            highlights, admin flags). Requires auth; user-aware. 404 when the player is missing.
 */

export function useGetPlayerIdView<TData = Awaited<ReturnType<typeof getPlayerIdView>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlayerIdView>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlayerIdViewQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






